
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/service",
      function () {
        return require("private-next-pages/terms/service/index.tsx");
      }
    ]);
  